import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { postRequest } from "../../api/http";
import LoginApi from "../../api/LoginApi";
import { LoadingView } from "../common";
import "./Login.scss";
import OtpInput from "react-otp-input";
import toastr from "toastr";
import { ReactComponent as Logo } from "../../assets/images/LogoWith.svg";
import { Button } from "antd";
import axios from "axios";
function OtpPage() {
  const [otpValue, setOtpValue] = useState(null);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const handleOTPSubmit = async () => {
    console.log("came")
    try {
    //   setLoading(true);
    const { sessionInfo, phone } = location.state || {};
      if (!sessionInfo || !phone) throw new Error("Missing session information");

      const confirmationResult = window.confirmationResult;
      if (!confirmationResult) throw new Error("Firebase confirmation not available");

      // Verify OTP
      const userCredential = await confirmationResult.confirm(otpValue);
      const user = userCredential.user;

      // Fetch tokens
      const accessToken = await user.getIdToken(true);
      const refreshToken = user.refreshToken;
      const data = {
        phoneNumber: phone,
        loginTypeAsCampusAmbassador: true,
      };
      const response = await axios.post(LoginApi.loginCA(), data, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });
      if (response.data.isUserRegistered) {
        localStorage.setItem("token", accessToken);
        localStorage.setItem("refreshToken", refreshToken);
        navigate("/", { replace: true });
      } else {
        throw new Error("Not a valid user");
      }

    } catch (e) {
      let errorMessage = "Something went wrong...";
    
      console.error("Error in handleOTPSubmit:", e);
    
      // Handle Firebase errors with custom messages
      if (e.code && e.message) {
        switch (e.code) {
          case "auth/invalid-verification-code":
            errorMessage = "The OTP you entered is invalid. Please try again.";
            break;
          case "auth/session-expired":
            errorMessage = "The OTP session has expired. Please request a new OTP.";
            break;
          case "auth/missing-verification-code":
            errorMessage = "Please enter the OTP sent to your phone.";
            break;
          default:
            errorMessage = e.message;
        }
      }
      // Handle Axios errors
      else if (e.response && e.response.data) {
        if (e.response.data.message) {
          errorMessage = e.response.data.message;
        } else if (e.response.data.error && e.response.data.error.message) {
          errorMessage = e.response.data.error.message;
        } else if (typeof e.response.data === "string") {
          errorMessage = e.response.data;
        }
      }
      // Handle custom or generic errors
      else if (e.message) {
        errorMessage = e.message;
      }
      // Handle string errors
      else if (typeof e === "string") {
        errorMessage = e;
      }
    
      toastr.error(errorMessage);
      setLoading(false);
      navigate("/login", { replace: true });
    }
  };
  
  useEffect(() => {
    if (location?.state?.sessionInfo === undefined)
      navigate("/login", { replace: true });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleOTPChange = (e) => {
    setOtpValue(e);
  };
  function ImageLogo() {
    return <Logo width={200} height={38} />;
  }
  if (loading) return <LoadingView />;
  return (
    <div className="loginPage">
      <div className="loginContainer">
        <div className="loginRow">
          <div className="loginCol loginBg"></div>
          <div className="loginCol loginForm">
            <div className="loginLogo">
              <Link to="/login">
                <ImageLogo />
              </Link>
            </div>
            <div className="loginFormBox">
              <div className="verify-heading">
                <h1 className="main">Phone Verification</h1>
                <p className="sub">Enter your OTP here</p>
              </div>
              <div className="verify-input">
                <OtpInput
                  className="otpFields"
                  isInputNum={true}
                  shouldAutoFocus={true}
                  numInputs={6}
                  value={otpValue}
                  onChange={handleOTPChange}
                  hasErrored={true}
                />
                <div className="spacer"></div>
                <Button
                  type="primary"
                  className="button-primary text-regular submit-otp"
                  onClick={handleOTPSubmit}
                  disabled={loading || otpValue?.length !== 6}
                >
                  Verify OTP
                </Button>
              </div>

              <div className="loginCopyRight">
                <p>Terms and Conditions, Copyrights @TimBuckDo</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="recaptcha" style={{ display: "none" }}></div>
    </div>
  );
}

export default OtpPage;
